module.exports = __webpack_public_path__ + "img/findOil.e3247e5e.png";